import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from "src/app/services/app/app.service";
import { DatePipe } from "@angular/common";
import { CommonService } from 'src/app/services/common/common.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-edit-break-time",
  templateUrl: "./edit-break-time.component.html",
  styleUrls: ["./edit-break-time.component.scss"],
})
export class EditBreakTimeComponent {
  public form!: FormGroup;
  constructor(
    private fb: FormBuilder,
    private recruiterService: RecruiterService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private appService: AppService,
    private commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public dialogRef: MatDialogRef<EditBreakTimeComponent>
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      br_tio: '',
      br_tii: ''
    });
    if (this.dialogData.type == "break") {
      this.form.get("br_tii")?.setValue(this.dialogData.br_tii);
      this.form.get("br_tio")?.setValue(this.dialogData.br_tio);
      // this.form.get("j_id")?.setValue(this.dialogData.j_id);
    }
  }
  saveBreakTime(): void {
    if (this.form.invalid) {
      return;
    }
    const { br_tii, br_tio } = this.form.value;
    let obj = {
      "j_id": this.dialogData.j_id,
      "clock_id": this.dialogData.clock_id,
      "st_ti": this.dialogData.st_ti,
      "ed_ti": this.dialogData.ed_ti,
      "em_i": this.dialogData.em_i,
      "date": this.dialogData.date,
      "br_tii": br_tii,
      "br_tio": br_tio
    }
    this.spinner.show();
    this.recruiterService.editBreakTime(obj).subscribe({
      next: (data: any) => {
        this.spinner.hide();
        if (data["status"] == 200) {
          this.appService.showToastMessage("success", data["msg"]);
          this.dialogRef.close({ add_quick_task: true });
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onCancel() {
    this.dialogRef.close();
  }
}
